<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">短信</a></li>
                <li><a href="#">发送视频短信</a></li>
            </ul>
        </div>
        <div id="usual1" class="usual">  
  	        <div class="formbody">    
                <div class="formtitle">
                    <span>发送视频短信</span>
                </div>  
                <div class="forminfo Vdbox">
                    <div class="left">
                        <ul class="forminfo" v-show="isShowSmsSend">                        
                            <li><label>1选模板<b>*</b></label>
                                <div class="vocation">   
                                    <button @click="showTemplate()" type="button" class="el-button el-button--primary el-button--small"><span>{{selectTemplateButValue}}<i class="el-icon-arrow-down el-icon--right wh"></i></span></button>                     
                                    <b>视频短信的费用从总账户扣除,请保持总账户余额充足</b> 
                                </div>
                            </li>
                            <li><label>2发送标题<b>*</b></label>
                                <div class="vocation">   
                                    <input type="text" class="dfinput maringht10" placeholder="请输入发送标题(不作为内容发送)" v-model="sendTitle" />
                                </div>
                            </li>
                            <li><label>3接收号<b>*</b></label><textarea name="" cols="" rows="" v-model="mobile" class="textinput left maringht10"></textarea></li>
                            <li>
                                <label>4选择通道<b>*</b></label>
                                <el-select v-model="channel" style="width:500px;" placeholder="请先选择模板" >
                                    <el-option
                                        v-for="item in channelList"
                                        :key="item.channelCode"
                                        :label="item.channelDesc + ',费用' + item.channelFee + '元/号码'"
                                        :value="item.channelCode">
                                    </el-option>
                                </el-select>
                            </li>
                            <!-- <li><label> &nbsp; </label><div class="buttonupload  click maringht10"> 通讯录添加 </div> <div class="buttonupload  click maringht10"> 文件导入（txt记事本格式） </div><div class="buttonupload  click maringht10"> 个性短信 </div> <div class="buttonupload  click maringht10"> 导入群发记录 </div></li> -->
                            <li class="mt50">
                                <label>&nbsp;</label>
                                <input class="sure" type="button" value="下一步" @click="next()">&nbsp;
                                <!-- <input class="cancel" type="button" value="存到草稿箱"> -->
                            </li>
                        </ul>
                        <ul class="forminfo" v-show="isShowSmsConfirm">
                            <li><label>模板</label>
                                <div class="vocation">   
                                    <button type="button" disabled="disabled" class="el-button el-button--primary el-button--small"><span>{{selectTemplateButValue}}<i class="el-icon-arrow-down el-icon--right wh"></i></span></button>  
                                    <b>视频短信的费用从总账户扣除,请保持总账户余额充足</b>              
                                </div>
                            </li>
                            <li><label>发送标题</label>
                                <div class="vocation">   
                                    <input type="text" class="dfinput maringht10" v-model="sendTitle" disabled="disabled" />
                                </div>
                            </li>
                            <li><label>接收号</label><textarea name="" cols="" rows="" v-model="mobile" class="textinput left maringht10" disabled="disabled"></textarea></li>
                            <li><label>通道编号</label><input type="text" class="dfinput maringht10" v-model="channel" disabled="disabled" /></li>
                            <li><label style="font-size:18px;color:red">注意：</label>
                                <div class="toolbars lh33" style="font-size:18px;color:red">视频短信一旦提交，就无法撤回，请慎提交！ </div>
                            </li>
                            <li><label>&nbsp;</label><input class="btn" :disabled="sendbtndisabled"  type="button" @click="videoSmsSend()" value="确定发送">&nbsp;
                                <input class="cancel" type="button" @click="confirmcancel()" value=" 修 改 ">
                            </li>
                        </ul>
                    </div>


                    <div class="left Vdeomission">
                        <h1 class=" f16">预览页面</h1>
                        <div class="lh33  c999">不同厂商得手机展现效果不一样，最终以手机为准。</div>        
                        <div class="phonediv">                        
                            <div class="phonetop"><img src="../../assets/images/phonetop.jpg" alt="top1"></div> 
                            <div  class="phonebox">
                                <ul> 
                                    <li class="phoneboxa">
                                        <div class="showDiv">
                                            <div class="phonetext">{{title}}</div>
                                        </div>
                                    </li>
                                    <li v-for="(item,index2) in templateList" class="phoneboxa">
                                        <div class="showDiv">
                                            <div v-if="item.templateType=='txt'" class="phonetext">{{item.templateContent}}</div>
                                            <div v-else-if="item.templateType == 'img'" class="phoneimg">
                                                <img :src="item.templateContent" title="图片" >
                                            </div>
                                            <div v-else-if="item.templateType=='video'" class="phonevideo">
                                                <video :src="item.templateContent"  controls="controls" style="width: 240px;">您的浏览器不支持 video 标签。</video>
                                            </div>
                                            <div v-else-if="item.templateType=='audio'" class="phoneVF">
                                                <img :src="item.templateContent" title="音频文件" >
                                            </div>
                                        </div>
                                    </li>                                      
                                </ul>
                            </div>
                        </div>

                    </div>

                </div>
                <!--发送视频短信-->
    
                <div class="jian">&nbsp;</div>
                <div class="welinfo">
                <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                <b>注意</b>
                </div>
    
                <ul class="infolist">
                <li><span class="ea2020">您还可发约XXX条短信，请注意号码数量、字数、通道价格！ 扣费字符是指：中文、英文、符号、空格、回车，每一个字符是代表一个字 </span></li>
                <li><span>短信问题排查方法</span></li> 
                <li><span>1、接收号码正确否</span></li>
                <li><span>2、是否欠费停机，当时不在服务区，或基站信号屏蔽有问题，可试拨打</span></li>
                <li><span>3、安装过短信过滤软件否，如360之类</span></li>
                <li><span>4、有否投诉过，被列入运营商白名单、黑名单、红名单</span></li>
                <li><span>5、是否使用的通道有延时，节假日可能拥堵</span></li>
                <li><span>6、内容有否包含关键敏感字，政治、诈骗、中奖、抽奖等过于广告夸张字眼，被当地接收运营商屏蔽以上自查皆无问题，可再联络二办客服 </span></li>
                <li><span>淘宝网店数据导入 注意：请进入快递到/网店管理－数据导入－导入CSV文件</span></li>
                <li><span class="ea2020">特别提醒、使用须知说明: </span><a class="ibtn">点击查看详细</a></li>
                <li><span class="ea2020">限制内容及发送时间说明: </span><a class="ibtn">点击查看详细</a></li>
                </ul>
            </div>
	    </div> 
        <el-dialog
            title="选择模板"
            :visible.sync="dialogVisible"
            width="800px"
            :before-close="handleClose">
            
            <div class="templatelist">
                <ul>                
                    <li class="listbox left" v-for="(item,index) in list">
                        <div class="blueidea">
                            <div class="blueideaimg">
                                <div v-for="item2 in item.templateContent">
                                    <ol v-if="item2.templateType == 'txt'">{{item2.templateContent}}</ol>
                                    <ol v-if="item2.templateType == 'img'"><img :src="item2.templateContent" /></ol>
                                    <ol v-if="item2.templateType == 'img'"><img :src="item2.templateContent" /></ol>
                                    <ol v-if="item2.templateType == 'img'"><img :src="item2.templateContent" /></ol>
                                </div>
                            </div>
                        </div>
                        <div>{{item.title}}</div>
                        <div class="content">
                            <div style="margin-left: 30%">
                                <el-button type="primary" plain @click="selectTemplate(index, item.id,item.title)">选&nbsp;&nbsp;&nbsp;&nbsp;择</el-button>
                            </div>
                            <div class=" right  help-tip1">
                                <div class="helpbox">
                                    <span>模板编号： {{item.id}}</span>
                                    <span>模板主题：{{item.title}}</span>
                                    <span v-if="item.state == 0">审核结果：审核中</span>
                                    <span v-else-if="item.state == 0">审核结果：审核通过</span>
                                    <span v-else-if="item.state==3">审核结果：未提交</span>
                                    <span v-else>审核结果：审核不通过</span>
                                    <span v-if="item.state==3"> 模板状态：草稿</span>
                                    <span v-else>模板状态：正常</span>
                                    <span>运营商：--</span>
                                    <span>创建时间：{{item.createTime}}</span>
                                </div>
                            </div>
                        </div>
                    </li> 
                </ul>
            </div>
            <div class="pagin">
                <el-pagination
                    :current-page="pageIndex"
                    layout="total, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
import faxsendVue from '../fax/faxsend.vue';
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            dialogVisible: false,
            pageIndex:0,
            totalCount:0,
            list:[],
            loadingShow:false,
            selectTemplateButValue:this.$route.query.btv == undefined ? '请选择模板' : this.$route.query.btv,
            templateList:[],
            id:this.$route.query.id == undefined ? "" : this.$route.query.id,
            sendTitle:'',
            title:'',
            mobile:'',
            isShowSmsSend: true,
            isShowSmsConfirm:false,
            sendbtndisabled:false,
            channel:'',
            channelList:[],
        }
    },
    mounted(){
        this.selectTemplateButValue = this.$route.query.btv == undefined ? '请选择模板' : this.$route.query.btv;
        this.id = this.$route.query.id == undefined ? "" : this.$route.query.id;
        if(this.id != ''){
            this.qrytemplatedetail(this.id);
            this.selectChannelCode(this.id);
        }
    },
    methods:{
        showTemplate(){
            this.dialogVisible = true;
            this.pageChange(1);
        },
        handleClose(){
            this.dialogVisible = false;
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            let that = this;
            let data = {'pageIndex':pageIndex,'pageSize':20, title:'',state:'1'};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/pagevideosmstemplate.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                //console.log(res);
                if('0000000' == res.data.code)
                {
                    that.list = [];
                    res.data.list.map((item,index)=>{
                        if(item.ydCheckFlag == 1 || item.ltCheckFlag == 1 || item.dxCheckFlag == 1)
                        {
                            if(typeof item.templateContent == 'string'){
                                item.templateContent = JSON.parse(item.templateContent)
                            }
                            that.list.push(item);
                        }
                        
                    })
                    //that.list = res.data.list;
                    that.pageIndex = parseInt(pageIndex);
                    that.totalCount = res.data.page.totalCount;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        selectTemplate(index, id, title){
            this.selectTemplateButValue = title;
            this.dialogVisible = false;
            this.templateList = this.list[index].templateContent;
            this.title = this.list[index].title;
            this.id = id;
            this.channelList = [];
            let channelDesc = '';
            console.log(JSON.stringify(this.list[index]));
            if(this.list[index].ltCheckFlag == 1 && this.list[index].ydCheckFlag == 1 && this.list[index].dxCheckFlag==1)
            {
                channelDesc = "支持三网";
            }
            else
            {
                channelDesc = "只支持";
                if(this.list[index].ydCheckFlag == 1)
                {
                    channelDesc = channelDesc + "移动,"
                }
                if(this.list[index].ltCheckFlag == 1)
                {
                    channelDesc = channelDesc + "联通,"
                }
                if(this.list[index].dxCheckFlag == 1)
                {
                    channelDesc = channelDesc + "电信,"
                }
            }
            let channelFee = this.list[index].channelFee;
            let channelCode = this.list[index].id;
            this.channelList = [{'channelCode':channelCode, 'channelDesc':channelDesc, 'channelFee':channelFee}]
            console.log(JSON.stringify(this.channelList));
            this.channel = channelCode;
            //this.selectChannelCode(id);
        },
        selectChannelCode(id){
            let that = this;
            let data = {'vstId':id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/qryvideosmschannel.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                //console.log(res);
                if('0000000' == res.data.code)
                {
                    that.channelList = res.data.videoSmsChannelList;
                    if(that.channelList != undefined && that.channelList.length == 1){
                        that.channel = that.channelList[0].channelCode;
                    }
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        next(){
            if(this.id == ''){
                alert("请先选择模板！");
                return;
            }
            if(this.sendTitle ==''){
                alert("请先填写发送标题！");
                return;
            }
            if(this.mobile == ''){
                alert("请先填写接收的手机号码！");
                return;
            }
            if(this.channel == ''){
                alert("请先选择发送通道！");
                return;
            }
            this.isShowSmsSend = false;
            this.isShowSmsConfirm = true;
        },
        confirmcancel(){
            this.isShowSmsSend = true;
            this.isShowSmsConfirm = false;
        },
        videoSmsSend(){
            let that = this;
            let data = {'vstId':this.id,sendTitle:this.sendTitle,mobile:this.mobile,channel:this.channel};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/sendvideosms.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                //console.log(res);
                if('0000000' == res.data.code)
                {
                    alert("视频短信已提交成功，客服审核后自动发送，切勿重复提交！");
                    that.$router.push('/smscheck')
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        qrytemplatedetail(id){
            let that = this;
            let data = {'id':id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/qrytemplatedetail.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                //console.log(res);
                if('0000000' == res.data.code)
                {
                    that.templateList = JSON.parse(res.data.videoSmsTemplate.templateContent);
                    that.title = res.data.videoSmsTemplate.title;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/sms/videosmssend.vue